<template>
  <main v-if="loaded">
    <section-view class="header" title="特色调理项目">
      <p>
        <span>{{info.item_dict_name}}</span>
        <i></i>
      </p>
      <img class="icon" v-if="info.image_url" :src="info.image_url"/>
    </section-view>

    <text-card title="调理说明" :content="info.item_explain"></text-card>

    <text-card title="调理周期" :content="info.lack_susceptibility"></text-card>

    <waterfall-card
        v-if="info.show_shentizhuyaotiaolixiang.length > 0"
        title="身体主要调理项"
        :list="info.show_shentizhuyaotiaolixiang"
        labelKey="item_dict_name"
        simpleLabelKey="item_dict_name_simple"
        :valueKey="avValueKey"
        colorKey="color"
    ></waterfall-card>

    <waterfall-card
        v-if="info.show_yingyangsuzhuyaotiaolixiang.length > 0"
        title="营养素主要调理项"
        :list="info.show_yingyangsuzhuyaotiaolixiang"
        labelKey="item_dict_name"
        simpleLabelKey="item_dict_name_simple"
        :valueKey="avValueKey"
        colorKey="color"
    ></waterfall-card>

    <waterfall-card
        v-if="info.show_tigaoxiangmuduibitu && info.show_tigaoxiangmuduibitu.length > 0"
        title="提高项目对比图"
        :list="info.show_tigaoxiangmuduibitu"
        labelKey="item_dict_name"
        :valueKey="valueKey"
        legend
    ></waterfall-card>

    <!-- 详细数据报告表 -->
    <table-card title="详细数据报告表" :columns="columns" :list="info.show_xiangxishujubaogaobiao" custom></table-card>

    <!-- 特别注意 -->
    <text-card title="特别注意" :content="info.nutrient_conditioning"></text-card>
  </main>
</template>

<script>
  import WaterfallCard from "@/components/WaterfallCard";
  import TableCard from "@/components/TableCard";
  import SectionView from "@/components/SectionView";
  import TextCard from "@/components/TextCard";
  import {getReportConditioningInfoH5} from "../net/api";

  export default {
    name: "Condition",
    components: {TextCard, SectionView, TableCard, WaterfallCard},

    data() {
      return {
        // 当前数据是否加载完成
        loaded: false,
        packageNo: '',
        checkcode: '',
        rand: '',
        re_id: '',

        code: '',

        // 平均值关联项
        avValueKey: {
          av: '平均值',
        },

        // 通用态图列表数据关联项
        valueKey: {
          av_old: '上次检测',
          av: '本次检测',
        },


        columns: {
          item_dict_name: '检测项目',
          av: '平均值'
        },

        // 调理数据
        info: {
          item_dict_name: '',
          image_url: null,
          item_explain: '',
          lack_susceptibility: '',
          nutrient_conditioning: '',
          show_shentizhuyaotiaolixiang: [],
          show_yingyangsuzhuyaotiaolixiang: [],
          show_tigaoxiangmuduibitu: [],
          show_xiangxishujubaogaobiao: []
        }
      }
    },

    created() {
      const query = this.$router.currentRoute.query;
      this.packageNo = query.packageNo;
      this.checkcode = query.checkcode;
      this.rand = query.rand;
      this.re_id = query.re_id;

      this.code = query.code;

      this.syncPageData();
    },

    methods: {
      syncPageData() {
        getReportConditioningInfoH5({
          packageNo: this.packageNo,
          rand: this.rand,
          checkcode: this.checkcode,
          system_code: this.code,
          re_id: this.re_id
        }).then((data) => {
          this.info = data;
          this.loaded = true;
        })
      }
    }
  }
</script>

<style lang="scss" scoped>
  .header {
    background-color: #D8E8FF;
    min-height: 300px;
    background-image: url("../assets/recuperate/header.png");
    background-size: 246px 274px;
    background-repeat: no-repeat;

    p {
      position: relative;
      padding: 0 10px 0 0;
      height: 70px;
      line-height: 58px;
      margin-top: 30px;
      margin-left: 50px;
      display: inline-block;

      span {
        position: relative;
        font-size: 50px;
        font-weight: 500;
        color: #333333;
        z-index: 1;
      }

      i {
        position: absolute;
        content: "";
        display: block;
        left: 0;
        width: 100%;
        height: 18px;
        background: #8DB6F2;
        border-radius: 9px;
        bottom: 5px;
      }
    }

    .icon {
      position: absolute;
      width: 220px;
      height: 220px;
      right: 10px;
      top: -36px;
      animation: fadeIn .3s;
    }
  }
</style>